import { Anchor, Container, Stack, Text, Title } from '@mantine/core'
import type { ReactNode } from 'react'

import { useDocumentTitle } from '../../components/PageHeader'
import { StatusBanner } from '../../components/StatusBanner'

const LAST_UPDATED = 'Last updated: 27 October 2026'

/**
 * The shared frame for the public legal pages (`/privacy`, `/terms`, `/cookies`, `/delete-account`): these sit
 * outside the signed-in app shell, so none of them needs an existing session to be read (main.tsx renders them
 * outside the router and its ConsentGate). `/delete-account` additionally offers sign-in and deletion in place —
 * see DeleteAccountPage.tsx. A "Draft — under review" banner stays until the owner removes it.
 */
export function LegalPage(props: { title: string; children: ReactNode }) {
  useDocumentTitle(props.title)
  return (
    <Container size="sm" py="xl">
      <Stack gap="lg">
        <Stack gap={4}>
          <Anchor href="/today" fw={600} fz={20} c="var(--mantine-primary-color-filled)" td="none" style={{ letterSpacing: '0.02em' }}>
            Macrotide
          </Anchor>
          <Title order={1}>{props.title}</Title>
          <Text size="sm" c="dimmed">
            {LAST_UPDATED}
          </Text>
        </Stack>
        <StatusBanner tone="warning">Draft — under review.</StatusBanner>
        {props.children}
      </Stack>
    </Container>
  )
}
